import Link from '@mui/material/Link';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import LinkedInIcon from '@mui/icons-material/LinkedIn';
import FacebookIcon from '@mui/icons-material/Facebook';

function Social() {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      <Typography variant="body2" sx={{ mr: 1 }}>
        Følg Intoto på
      </Typography>
      <Link
        href="https://www.linkedin.com/company/intoto-as/"
        target="_blank"
        rel="noreferrer"
        underline="hover"
        title="LinkedIn"
      >
        <LinkedInIcon sx={{ display: 'block' }} />
      </Link>
      <Link
        href="https://www.facebook.com/intoto.io/"
        target="_blank"
        rel="noreferrer"
        underline="hover"
        title="Facebook"
      >
        <FacebookIcon sx={{ display: 'block' }} />
      </Link>
    </Box>
  );
}

export default Social;
